import { forwardRef } from 'react';

import type { TextFieldProps } from '../components/ui/text-field';
import { TextField } from '../components/ui/text-field';
import { useFieldContext, useFormContext } from './use-form.context';

type FormTextFieldProps = TextFieldProps & {};

const FormTextField = forwardRef<HTMLInputElement, FormTextFieldProps>(
  (props, ref) => {
    const form = useFormContext();
    const field = useFieldContext<string>();

    const isBlurred = field.state.meta.isBlurred;
    const isFormSubmitted = field.form.state.submissionAttempts > 0;
    const isFieldWithErrors = field.state.meta.errors.length > 0;

    return (
      <form.Subscribe selector={(state) => [state.isSubmitting]}>
        {([isSubmitting]) => (
          <TextField
            ref={ref}
            {...props}
            error={field.state.meta.errors[0]?.message}
            disabled={isSubmitting}
            value={field.state.value}
            onChange={(e) => field.handleChange(e.target.value)}
            onBlur={field.handleBlur}
            hasError={(isBlurred || isFormSubmitted) && isFieldWithErrors}
          />
        )}
      </form.Subscribe>
    );
  }
);
FormTextField.displayName = 'FormTextField';

export { FormTextField };
